import { LockOutlined } from "@ant-design/icons";
import { Form, Select, Spin } from "antd";
import { useState } from "react";
import SchemaFieldTitle from "../SchemaFieldTitle";
import Tooltip from "../Tooltip";
const { Option } = Select;

const PicklistInput = ({ value, onChange, items, fetchingData, isRequired, disabled }) => {
    const [picklistValue, setPicklistValue] = useState(value);

    const onPicklistValueChange = (value, option) => {
        setPicklistValue(value);
        onChange(value);
    };

    return (
        <Select
            defaultValue={value}
            value={picklistValue}
            onChange={onPicklistValueChange}
            loading={fetchingData}
            notFoundContent={fetchingData ? <Spin size="small" /> : undefined}
            allowClear={!isRequired}
            disabled={disabled}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
            {items && items.map((option, index) => <Option key={index} value={option.code}>{`${option.code}${option.description && ` (${option.description})`}`}</Option>)}
        </Select>
    );
};

function FormPicklistField({ fieldErrors, fieldId, name, description, isRequired, items, fetchingData, disabled = false, ...field }) {
    return (
        <Form.Item
            key={fieldId}
            name={[fieldId]}
            label={
                <div style={{ display: "flex", alignItems: "center" }}>
                    <SchemaFieldTitle name={name} tags={field.classifiers} orientation="horizontal" tagSummary={false} isPrimaryKey={field.isPrimaryKey} />
                    {field.isPII && (
                        <Tooltip title="Masked data due to PII restriction">
                            <LockOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
                        </Tooltip>
                    )}
                </div>
            }
            tooltip={description}
            rules={[
                {
                    required: isRequired,
                    message: `Value is required`,
                },
                {
                    validator(_, value) {
                        if (value && value.toString().trim() && fetchingData === false) {
                            for (let item of items) {
                                if (item.code === value.trim()) {
                                    return Promise.resolve();
                                }
                            }
                            return Promise.reject(`Invalid value. Value should be a valid picklist value`);
                        }
                        return Promise.resolve();
                    },
                },
            ]}
            {...fieldErrors}
        >
            <PicklistInput fetchingData={fetchingData} items={items} isRequired={isRequired} disabled={disabled} />
        </Form.Item>
    );
}

export default FormPicklistField;
